import { render, staticRenderFns } from "./move-group.vue?vue&type=template&id=0357df5c&scoped=true"
import script from "./move-group.vue?vue&type=script&lang=js"
export * from "./move-group.vue?vue&type=script&lang=js"
import style0 from "./move-group.vue?vue&type=style&index=0&id=0357df5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0357df5c",
  null
  
)

export default component.exports